<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import Faq from "../components/home/Faq.svelte";
	import type { FrequentlyAskedQuestionsProps } from "./FrequentlyAskedQuestionsProps.js";

	const _: FrequentlyAskedQuestionsProps = $props();
</script>

<Layout>
	<Faq h1={true} page="faq" />
</Layout>
